import styled from "styled-components";

export const StyledPageInput = styled.div`
  display: flex;
  width: 3.625rem;
  padding: 0.625rem 0;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 0.5rem;
  border: 2px solid #000;
  background: #fff;
`;
